<template>
  <vs-popup id="popupRiskInfo" title="위험성평가 기준표" :active.sync="popupActiveSync">
    <div class="p-4">
      <div class="risk-info-header">
        <span style="grid-area: A; border-bottom: none; font-weight: bold;">위험성결정</span>
        <span style="grid-area: B; border-right: none; display: block;">
          <p style="text-align: center;">가로 : 중대성(강도)</p>
          <p style="text-align: center;">세로 : 가능성(빈도)</p>
        </span>
        <span style="grid-area: C; border-right: none; ">최대(4)</span>
        <span style="grid-area: D; border-right: none; ">대(3)</span>
        <span style="grid-area: E; border-right: none; ">중(2)</span>
        <span style="grid-area: F; ">소(1)</span>

      </div>
      <div>
        <div class="risk-info-body">
          <div>
            <div><span style="border-top: none; border-right: none; background-color: #F9F9F9;">최상(5)</span></div>
          </div>
          <div>
            <div><span style="border-top: none; border-right: none; color: #E42728">매우높음</span></div>
          </div>
          <div>
            <div><span style="border-top: none; border-right: none; color: #E42728">높음</span></div>
          </div>
          <div>
            <div><span style="border-top: none; border-right: none; color: #E42728">약간높음</span></div>
          </div>
          <div>
            <div><span style="border-top: none; color: #FF8510">낮음</span></div>
          </div>
        </div>

        <div class="risk-info-body">
          <div>
            <div><span style="border-top: none; border-right: none; background-color: #F9F9F9;">상(4)</span></div>
          </div>
          <div>
            <div><span style="border-top: none; border-right: none; color: #E42728">매우높음</span></div>
          </div>
          <div>
            <div><span style="border-top: none; border-right: none; color: #E42728">약간높음</span></div>
          </div>
          <div>
            <div><span style="border-top: none; border-right: none; color: #E42728">보통</span></div>
          </div>
          <div>
            <div><span style="border-top: none; color: #FF8510">낮음</span></div>
          </div>
        </div>

        <div class="risk-info-body">
          <div>
            <div><span style="border-top: none; border-right: none; background-color: #F9F9F9;">중(3)</span></div>
          </div>
          <div>
            <div><span style="border-top: none; border-right: none; color: #E42728">약간높음</span></div>
          </div>
          <div>
            <div><span style="border-top: none; border-right: none; color: #E42728">약간높음</span></div>
          </div>
          <div>
            <div><span style="border-top: none; border-right: none; color: #FF8510">낮음</span></div>
          </div>
          <div>
            <div><span style="border-top: none; color: #28C76F">매우낮음</span></div>
          </div>
        </div>

        <div class="risk-info-body">
          <div>
            <div><span style="border-top: none; border-right: none; background-color: #F9F9F9;">하(2)</span></div>
          </div>
          <div>
            <div><span style="border-top: none; border-right: none; color: #E42728">보통</span></div>
          </div>
          <div>
            <div><span style="border-top: none; border-right: none; color: #FF8510">낮음</span></div>
          </div>
          <div>
            <div><span style="border-top: none; border-right: none; color: #FF8510">낮음</span></div>
          </div>
          <div>
            <div><span style="border-top: none; color: #28C76F">매우낮음</span></div>
          </div>
        </div>

        <div class="risk-info-body">
          <div>
            <div><span style="border-top: none; border-right: none; background-color: #F9F9F9;">최하(1)</span></div>
          </div>
          <div>
            <div><span style="border-top: none; border-right: none; color: #FF8510">낮음</span></div>
          </div>
          <div>
            <div><span style="border-top: none; border-right: none; color: #28C76F">매우낮음</span></div>
          </div>
          <div>
            <div><span style="border-top: none; border-right: none; color: #28C76F">매우낮음</span></div>
          </div>
          <div>
            <div><span style="border-top: none; color: #28C76F">매우낮음</span></div>
          </div>
        </div>
      </div>


      <div class="risk-info-header-second mt-4">
        <span style="border-right: none; ">위험성수준</span>
        <span>관리기준</span>
      </div>

      <div class="risk-info-body-second">
        <div>
          <div><span style="border-top: none; border-right: none;">16~20</span></div>
        </div>
        <div>
          <div><span style="border-top: none; border-right: none; color: #E42728">매우높음</span></div>
        </div>
        <div>
          <div><span style="border-top: none;">즉시 작업중지(작업을 지속하려면 즉시 개선을 실행하는 위험)</span></div>
        </div>
      </div>

      <div class="risk-info-body-second">
        <div>
          <div><span style="border-top: none; border-right: none;">15</span></div>
        </div>
        <div>
          <div><span style="border-top: none; border-right: none; color: #E42728">높음</span></div>
        </div>
        <div>
          <div><span style="border-top: none;">긴급 임시안전보건대책을 세운 후 작업을 실시하고 정비, 보수기간 전에 안전보건대책을 수립하고 개선해야 할 위험</span></div>
        </div>
      </div>

      <div class="risk-info-body-second">
        <div>
          <div><span style="border-top: none; border-right: none;">9~12</span></div>
        </div>
        <div>
          <div><span style="border-top: none; border-right: none; color: #E42728">약간높음</span></div>
        </div>
        <div>
          <div><span style="border-top: none;">즉시개선</span></div>
        </div>
      </div>

      <div class="risk-info-body-second">
        <div>
          <div><span style="border-top: none; border-right: none;">8</span></div>
        </div>
        <div>
          <div><span style="border-top: none; border-right: none; color: #E42728">보통</span></div>
        </div>
        <div>
          <div><span style="border-top: none;">안전대책 수립, 안전표지·수칙 및 정보제공, 주기적 안전보건교육의 제공이 필요한 위험</span></div>
        </div>
      </div>

      <div class="risk-info-body-second">
        <div>
          <div><span style="border-top: none; border-right: none;">4~6</span></div>
        </div>
        <div>
          <div><span style="border-top: none; border-right: none; color: #FF8510">낮음</span></div>
        </div>
        <div>
          <div><span style="border-top: none;">관리적 대책 및 안전작업준수, 교육, 독려 등의 제공이 필요한 위험</span></div>
        </div>
      </div>

      <div class="risk-info-body-second">
        <div>
          <div><span style="border-top: none; border-right: none;">1~3</span></div>
        </div>
        <div>
          <div><span style="border-top: none; border-right: none; color: #28C76F">매우낮음</span></div>
        </div>
        <div>
          <div><span style="border-top: none;">현재의 안전대책 유지</span></div>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
  components: {
  },
  computed: {
    popupActiveSync: {
      get () {
        return this.value
      },
      set () {
        this.handleCloseSelf()
      }
    }
  },
  methods: {
    handleCloseSelf () {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.risk-info-body {
  display: grid;
  grid-template-columns: 228px 228px 228px 228px 228px;
  span {
    padding: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #DEDEDE;

    &.left {
      justify-content: flex-start;
    }
  }
}
.risk-info-header {
  display: grid;
  grid-template-columns: 228px 228px 228px 228px 228px;
  grid-template-areas: "A A A A A" "B C D E F";
  grid-template-rows: 40px 50px;
  background-color: #F9F9F9;
  span {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #DEDEDE;
  }
}
.risk-info-header-second {
  display: grid;
  grid-template-columns: 327px 812px;
  background-color: #F9F9F9;
  span {
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #DEDEDE;
  }
}
.risk-info-body-second {
  display: grid;
  grid-template-columns: 163px 164px 812px;
  span {
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #DEDEDE;

    &.left {
      justify-content: flex-start;
    }
  }
}
</style>
<style>

#popupRiskInfo > .vs-popup {
  width: 1167px !important;
}

#popupRiskInfo > .vs-popup > .vs-popup--content {
  width: 100%;
  padding: 0;
  margin: 0;
}

#popupRiskInfo > .vs-popup > .vs-popup--content > .vs-row {
  padding: 24px;

}

</style>
